import React from 'react';
import { Link } from 'react-router-dom';

function ReviewsSentPanel({ reviews, loading, emptyMessage }) {
  if (loading) return <div className="loading">Loading sent reviews...</div>;

  if (!reviews || reviews.length === 0) {
    return (
      <div className="dashboard-panel">
        <h3>Reviews Sent</h3>
        <div className="empty-state">{emptyMessage || 'No reviews sent yet.'}</div>
      </div>
    );
  }

  return (
    <div className="dashboard-panel">
      <h3>Reviews Sent</h3>
      <div className="dashboard-table-wrapper">
        <table className="file-table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Status</th>
              <th>Approvals</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review) => (
              <tr key={review.fileId}>
                <td className="file-name-cell">
                  <Link to={`/review/${review.fileId}`}>{review.fileName}</Link>
                </td>
                <td>
                  <span className={`badge badge-${review.status === 'Approved' ? 'success' : review.status === 'Rejected' ? 'danger' : 'warning'}`}>
                    {review.status}
                  </span>
                </td>
                <td>{review.approvedCount}/{review.totalApprovers}</td>
                <td>{new Date(review.createdAt).toLocaleDateString('en-US', { timeZone: 'America/Chicago' })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReviewsSentPanel;
